
<div *ngIf="_spec">
    <div #container id="editor-container">
      <akit-exercise-editor
          enable-preview="false"
          enable-id-field="false"
          audiences='[ {"name": "English", "id": "uk_KS5"}, {"name": "Dutch", "id":"vwo-b"}]'
          allow-assets="false"
      ></akit-exercise-editor>
    </div>

    <div *ngIf="showPreview">
        <div id="button-container">
            <button class="form-control" (click)="testExercise()">Test</button>
            <button class="form-control" (click)="clearExerciseClicked()">New</button>
        </div>
        <div id="preview-container">
            <akit-exercise-preview  #preview [attr.exercise-id]="_spec.id" show-run-button="false"></akit-exercise-preview>
        </div>
    </div>
    
</div>
  